import DatePicker from './DatePicker';

export type { DatePickerProps, RangeType } from './DatePicker';
export default DatePicker;
